<aca-page-layout>
  <aca-page-layout-content [scrollable]="true">
    <adf-about [dev]="dev" [pkg]="pkg"> </adf-about>
  </aca-page-layout-content>
</aca-page-layout>
